export var Name = 'user-upgrade-requested';
export var UseUpgradeRequested = Name;